import {
  div,
  h1,
  h2,
  table,
  thead,
  tbody,
  tr,
  th,
  td,
  span,
  input,
  button,
  fnstate,
  label
} from '@srfnstack/fntags'

export const Tenants = () => {
  const tenants = fnstate([])
  const loading = fnstate(true)
  const creating = fnstate(false)
  const newTenant = fnstate({ name: '', domain: '' })

  const fetchTenants = async () => {
    loading(true)
    try {
      const res = await fetch('/api/system/tenants')
      if (res.ok) tenants(await res.json())
    } catch (err) {
      console.error('Failed to fetch tenants:', err)
    } finally {
      loading(false)
    }
  }

  const handleCreate = async () => {
    creating(true)
    try {
      const res = await fetch('/api/system/tenants', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newTenant())
      })
      if (res.ok) {
        newTenant({ name: '', domain: '' })
        fetchTenants()
      }
    } catch (err) {
      console.error('Failed to create tenant:', err)
    } finally {
      creating(false)
    }
  }

  const impersonateTenant = async (tenant) => {
    const res = await fetch('/api/system/impersonate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ tenantId: tenant.id })
    })
    if (res.ok) window.location.href = '/'
  }

  const toggleStatus = async (tenant) => {
    const newStatus = tenant.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
    try {
      const res = await fetch(`/api/system/tenants/${tenant.id}`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus })
      })
      if (res.ok) fetchTenants()
    } catch (err) {
      console.error('Failed to update tenant status:', err)
    }
  }

  fetchTenants()

  return div({ class: 'p-6 space-y-8' },
    h1({ class: 'text-3xl font-bold' }, 'Tenant Management'),

    // Create Tenant Section
    div({ class: 'card bg-base-100 border border-base-300 shadow-sm' },
      div({ class: 'p-6' },
        h2({ class: 'text-xl font-bold mb-4' }, 'Create New Tenant'),
        div({ class: 'flex flex-col md:flex-row gap-4' },
          div({ class: 'form-control flex-1' },
            label({ class: 'label' }, span({ class: 'label-text font-bold' }, 'Tenant Name')),
            input({
              type: 'text',
              class: 'input input-bordered',
              placeholder: 'Acme POD',
              value: newTenant.bindAttr(t => t.name),
              oninput: (e) => newTenant.assign({ name: e.target.value })
            })
          ),
          div({ class: 'form-control flex-1' },
            label({ class: 'label' }, span({ class: 'label-text font-bold' }, 'Custom Domain (optional)')),
            input({
              type: 'text',
              class: 'input input-bordered',
              placeholder: 'acme.etherbuildr.com',
              value: newTenant.bindAttr(t => t.domain),
              oninput: (e) => newTenant.assign({ domain: e.target.value })
            })
          ),
          div({ class: 'flex items-end' },
            button({
              class: 'btn btn-primary',
              disabled: creating.bindAttr(c => c),
              onclick: handleCreate
            }, 'Create Tenant')
          )
        )
      )
    ),

    // Tenant List Section
    div({ class: 'card bg-base-100 border border-base-300 shadow-sm' },
      div({ class: 'p-0 overflow-x-auto' },
        table({ class: 'table w-full' },
          thead(
            tr(
              th('ID'),
              th('Name'),
              th('Domain'),
              th('Subscription'),
              th('Status'),
              th('Actions'),
              th('')
            )
          ),

          loading.bindAs(l => l
            ? tbody(tr(td({ colspan: 6, class: 'text-center p-8' }, span({ class: 'loading loading-spinner' }))))
            : tenants.bindAs(list => list.length === 0
              ? tbody(tr(td({ colspan: 6, class: 'text-center p-8 opacity-50' }, 'No tenants found.')))
              : tbody(list.map(t => tr(
                td(t.id),
                td({ class: 'font-bold' }, t.name),
                td(t.domain || 'N/A'),
                td(div({ class: `badge badge-sm ${t.subscription_status === 'active' ? 'badge-success' : 'badge-ghost'}` }, t.subscription_status || 'free')),
                td(div({ class: `badge badge-sm ${t.status === 'ACTIVE' ? 'badge-success' : 'badge-error'}` }, t.status)),
                td(
                  button({
                    class: `btn btn-xs ${t.status === 'ACTIVE' ? 'btn-error btn-outline' : 'btn-success'}`,
                    onclick: () => toggleStatus(t)
                  }, t.status === 'ACTIVE' ? 'Deactivate' : 'Activate')
                ),
                td(
                  t.status === 'ACTIVE'
                    ? button({
                      class: 'btn btn-xs btn-warning gap-1',
                      onclick: () => impersonateTenant(t)
                    },
                    span({ class: 'material-symbols-rounded text-xs' }, 'manage_accounts'),
                    'View As'
                    )
                    : ''
                )
              ))
              )
            )
          )
        )
      )
    )
  )
}
